import React from "react";
import { Alert, Card } from "antd";
import { Column, Pie } from "@ant-design/charts";

import { pieToPlotData, seriesColorMap, stackedBarToPlotData } from "./dashboardProtoFormat";

function StackedBarChart({ chart }) {
  const data = stackedBarToPlotData(chart);
  const colors = seriesColorMap(chart);
  const isMoney = chart.format === "brl";
  return (
    <Column
      data={data}
      xField="category"
      yField="value"
      seriesField="group"
      isStack
      legend={{ position: "bottom" }}
      color={(datum) => colors[datum.group] || "#3A6EA5"}
      yAxis={{
        label: {
          formatter: (v) =>
            isMoney
              ? new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(Number(v))
              : new Intl.NumberFormat("pt-BR").format(Number(v)),
        },
      }}
    />
  );
}

function PieChart({ chart }) {
  const data = pieToPlotData(chart);
  return (
    <Pie
      data={data}
      angleField="value"
      colorField="type"
      innerRadius={0.62}
      legend={{ position: "right" }}
      color={chart.colors && chart.colors.length ? chart.colors : undefined}
      statistic={{
        title: { content: "TOTAL" },
        content: { content: String(chart.total || 0) },
      }}
    />
  );
}

export default function DashboardProtoChart({ chart, loading }) {
  if (!chart) return null;

  return (
    <Card title={chart.title || "Gráfico"} size="small" loading={loading} style={{ marginBottom: 16, height: "100%" }}>
      {chart.error ? <Alert type="warning" message={chart.error} style={{ marginBottom: 12 }} /> : null}
      {chart.type === "pie" ? <PieChart chart={chart} /> : <StackedBarChart chart={chart} />}
    </Card>
  );
}
